export default __webpack_public_path__ + "static/media/pilz-06.b68fc06b.png";